import { FormControlLabel, Switch } from "@mui/material";
import Input from "../../../../components/input/Input";
import Button from "../../../../components/Button";
import { useState } from "react";
import { useForm } from "react-hook-form";
import useCreateLecture from "../hooks/useCreateLecture";
import { useParams } from "react-router-dom";

function CreateLecture({ onCloseModal }) {
    const [isVisibile, setIsVisibile] = useState(true);
    const { courseId } = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const { createLecture, isCreating, error: ApiError } = useCreateLecture();

    function onSubmit({ name, brief, price }) {
        const visibility = isVisibile ? 1 : 0;
        //Send The Form Data To The API
        createLecture(
            {
                name,
                brief,
                visibility,
                price,
                courseId,
            },
            {
                onSuccess: () => {
                    reset();
                    onCloseModal?.();
                },
            }
        );
    }

    const handleChange = (event) => {
        setIsVisibile(event.target.checked);
    };
    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col items-center justify-center w-full gap-3"
        >
            <h3 className="py-5 text-xl text-blue-color-primary">
                إنشاء المحاضره
            </h3>
            <FormControlLabel
                control={
                    <Switch
                        checked={isVisibile}
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                        color="primary"
                    />
                }
                label="مفعل"
            />
            <div className="w-full py-5 space-y-7">
                <Input
                    label={"أسم المحاضره"}
                    name={"name"}
                    register={register("name", {
                        maxLength: {
                            value: 70,
                            message: "أسم الكورس يجب ان لا يزيد عن 70 حرف",
                        },
                        required: "برجاء إدخال أسم الكورس",
                    })}
                    error={
                        errors?.name?.message ||
                        ApiError?.response?.data?.errors?.name?.[0]
                    }
                    type="text"
                    size="fulWidth"
                    disabled={isCreating}
                />

                <Input
                    label={"الوصف"}
                    name={"brief"}
                    register={register("brief", {
                        maxLength: {
                            value: 250,
                            message: "الوصف الكورس يجب ان لا يزيد عن 250 حرف",
                        },
                        required: "برجاء إدخال وصف المحاضره",
                    })}
                    error={
                        errors?.brief?.message ||
                        ApiError?.response?.data?.errors?.brief?.[0]
                    }
                    type="text"
                    size="fulWidth"
                    disabled={isCreating}
                />

                <Input
                    label={"السعر"}
                    name={"price"}
                    register={register("price", {
                        required: "برجاء إدخال سعر المحاضره",
                    })}
                    error={
                        errors?.price?.message ||
                        ApiError?.response?.data?.errors?.price?.[0]
                    }
                    type="text"
                    size="fulWidth"
                    disabled={isCreating}
                />
            </div>

            <div className="w-full pt-3">
                <Button
                    type="primary"
                    className="w-full leading-8"
                    disabled={isCreating}
                >
                    إنشاء محاضره
                </Button>
            </div>
        </form>
    );
}

export default CreateLecture;
